import React from "react"

import FooterLogo from '../../../assets/images/footer-logo.png';
 

const AboutInfo = () => {
    return (
                <div>
                <img src={FooterLogo} alt="Footer Logo" />
                <p>Lovely to be heard and seen, get subscribed by choices, and reject
the complacency for what you already have experienced through
your implicit attempt towards searching for typical rental car
services near me all around you when you’re landing for the first
time in a city, they say Navi Mumbai.</p>
                </div>
    );
  }
  
  export default AboutInfo;